







































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import PageSection from "@/components/PageSection.vue";
import ClientsMixin from "@/mixins/http/ClientsMixin";
import QuotationsMixin from "@/mixins/http/QuotationsMixin";
import Page from "@/views/Page.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";
import SectionField from "@/components/SectionField.vue";
import { currentUserStore, quotationStore } from "@/store/typed";

import {
  CatalogueSetting,
  catalogueSettings,
  generalSettings,
  SettingEntry,
} from "../../models/Setting";
import { camelToUnderscore, startsWithVowel } from "../../utils/Typography";
import { showToast } from "../../utils/Toast";
import WithErrors from "@/directives/WithErrors";
import { ClientPayload } from "../../models/Client";

const tag = "create_client";
const QUOTATION_TAG = "create_quotation_tag";

@Component({
  directives: {
    WithErrors,
  },
  components: {
    PageSection,
    Page,
    SectionField,
  },
})
export default class ClientCreate extends Mixins(
  ClientsMixin,
  QuotationsMixin
) {
  @RegisterHttp(tag) readonly createClientRequest!: RequestData;

  client: ClientPayload = new ClientPayload();

  get loading() {
    return this.createClientRequest?.loading;
  }

  get currentUser() {
    return currentUserStore.currentUser;
  }

  get requestTag() {
    return tag;
  }

  get title() {
    if (quotationStore.isCreatingClient) {
      return `Add client for quotation ${quotationStore.suspendedQuotation.name}`;
    } else {
      return "Add client";
    }
  }

  back() {
    this.$router.go(-1);
  }

  async onCreate() {
    try {
      const client = await this.createClient(this.client, tag);
      showToast("Client created successfully");
      if (quotationStore.isCreatingClient) {
        quotationStore.dispatchSetCurrentClient(client);
        const quotation = await this.createQuotation(
          quotationStore.suspendedQuotation,
          QUOTATION_TAG
        );
        quotationStore.dispatchFinishClientCreation();
        this.$router.push({
          name: "quotation_edit",
          query: { edit: "1" },
          params: { id: quotation.id },
        });
      } else {
        this.back();
      }
    } catch (e) {
      showToast("An error occurred while creating the client", {
        type: "error",
      });
    }
  }

  mounted() {
    this.client.companyId = this.currentUser.company.slug;
  }

  destroyed() {
    if (quotationStore.isCreatingClient) {
      quotationStore.dispatchFinishClientCreation();
    }
  }
}
